import { useMutation } from '@tanstack/react-query';
import queryClient from 'src/services/queryClient';
import { SendRequestDTO } from 'src/types';

import { sendRequest } from '../event.request';

export function useSendExclusiveRequest(eventId: string) {
  return useMutation({
    mutationFn: async (data: SendRequestDTO) => sendRequest(eventId, data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['event', eventId] });
      await queryClient.invalidateQueries({ queryKey: [eventId] });
    },
  });
}
